import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

class Messaging extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className={`messaging ${this.props.classList}`}>
            {this.props.icon?<i className="icon"><FontAwesomeIcon icon={this.props.iconType} /></i>:""}{this.props.messageText}
      </div>
    );
  }
}

export default Messaging;
